import { render, staticRenderFns } from "./project.vue?vue&type=template&id=19e01a1c&scoped=true&"
import script from "./project.vue?vue&type=script&lang=js&"
export * from "./project.vue?vue&type=script&lang=js&"
import style0 from "./project.vue?vue&type=style&index=0&id=19e01a1c&lang=stylus&scoped=true&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e01a1c",
  null
  
)

export default component.exports